import { apiRequest } from './client';
import type {
  NativeSale,
  NativeSaleCancelResponse,
  NativeSaleCompletePaidResponse,
  NativeSaleDeclareUnpaidResponse,
  NativeSaleOpenInput,
  NativeSaleOpenResponse,
  NativeSalePaymentInput,
  NativeSalePaymentResponse,
} from '../types/nativeSales';

const PATH = '/api/sales';

/**
 * Native POS Lifecycle: ciclo de la venta nativa — abrir (durable, sin efectos) → cobrar (completa
 * y ejecuta los efectos una sola vez) → o cancelar antes de cobrar.
 *
 * El negocio NUNCA viaja en el cuerpo: lo deriva el backend de la sesión.
 */
export const openNativeSale = (input: NativeSaleOpenInput) => apiRequest<NativeSaleOpenResponse>(PATH, json('POST', input));

/** Cobro. Reintentar con la misma clave devuelve el mismo resultado sin cobrar dos veces. */
export const payNativeSale = (saleId: string, input: NativeSalePaymentInput) =>
  apiRequest<NativeSalePaymentResponse>(`${PATH}/${saleId}/payments`, json('POST', input));

export const cancelNativeSale = (saleId: string) =>
  apiRequest<NativeSaleCancelResponse>(`${PATH}/${saleId}/cancel`, { method: 'POST' });

/**
 * PAYPAL-DECLINE-01 · lote 5: cierra una venta DECLARANDO que no se cobro. Es lo que cancelar no
 * puede, porque el servidor no logro verificar ese cobro con tarjeta. Solo el dueno; el fundamento
 * es obligatorio y se guarda con la declaracion. El servidor impone que jamas se pueda declarar
 * encima de un cobro confirmado.
 */
export const declareNativeSaleUnpaid = (saleId: string, basis: string) =>
  apiRequest<NativeSaleDeclareUnpaidResponse>(`${PATH}/${saleId}/declare-unpaid`, json('POST', { basis }));

/**
 * FI-53: completa una venta cuyo cobro con lector YA está confirmado y que se quedó sin completar.
 * No cobra: no lleva método, importe ni clave, y sin un cobro confirmado el servidor responde 409.
 * Idempotente: una venta ya completada se devuelve tal cual.
 */
export const completePaidNativeSale = (saleId: string) =>
  apiRequest<NativeSaleCompletePaidResponse>(`${PATH}/${saleId}/complete-paid`, { method: 'POST' });

export const getNativeSale = (saleId: string) => apiRequest<{ sale: NativeSale }>(`${PATH}/${saleId}`);

/** Ventas que quedaron a medias (recarga, cierre de la app, pérdida de conexión). */
export const listPendingNativeSales = (storeId?: string) =>
  apiRequest<{ items: NativeSale[] }>(`${PATH}/pending${storeId ? `?storeId=${encodeURIComponent(storeId)}` : ''}`);

function json(method: string, body: unknown): RequestInit {
  return { method, body: JSON.stringify(body) };
}
